<template>
  <VDialog
    v-model="_dialog"
    persistent
    width="300"
  >
    <VCard
      color="primary"
      dark
    >
      <VCardText>
        {{ description }}
        <VProgressLinear
          v-model="_progressValue"
          :indeterminate="indeterminate"
          color="white"
          class="mb-0"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: 'ProgressDialogCard',
  props: {
    description: {
      type: String,
      default: ''
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: false
    },
    progressValue: {
      type: Number,
      default: 0
    }
  },
  computed: {
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    },
    _progressValue: {
      get () {
        return this.progressValue
      },
      set (val) {
        this.$emit('update:progressValue', val)
      }
    }
  }
}
</script>

<style scoped>

</style>
